import React from "react";
import { Box, BoxProps } from "@mui/material";

export const Column: React.FC<BoxProps> = ({ children, ...rest }) => (
  <Box display="flex" flexDirection="column" {...rest}>
    {children}
  </Box>
);
